import { DataTestId } from '../../../../core/types/data-props.js';
import { StylingProps } from '../../../../core/types/styling-props.js';
import { WithChildren } from '../../../../core/types/with-children.js';
import { InternalBaseItem as BaseItem } from '../form-field-messages/FormFieldMessageBaseItem.js';

/**
 * @public
 * @deprecated in favor of `FormFieldMessages`.
 */
export interface HintProps extends WithChildren, StylingProps, DataTestId {
  /**
   * Whether the connected input is currently disabled.
   * @defaultValue false
   */
  disabled?: boolean;
  /** Id to link the hint to its corresponding element. */
  id?: string;
}

/**
 * Renders a hint message if given, otherwise renders nothing.
 * @deprecated in favor of `FormFieldMessages`.
 * @public
 */
// oxlint-disable-next-line typescript/no-deprecated
export const Hint = (props: HintProps) => {
  // oxlint-disable-next-line typescript/no-deprecated
  const { children, ...remainingProps }: HintProps = props;

  return children ? (
    <BaseItem variant="hint" {...remainingProps}>
      {children}
    </BaseItem>
  ) : null;
};

// oxlint-disable-next-line typescript/no-deprecated
Hint.displayName = 'Hint';
